import React from 'react';
import { Navigate } from 'react-router-dom';
import { Center, Spinner, Text } from '@chakra-ui/react';
import { useAuth } from '../hooks/useAuth';

const PrivateRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <Center h="100vh" flexDirection="column">
        <Spinner size="xl" mb={4} />
        <Text>Caricamento...</Text>
      </Center>
    );
  }

  if (!user) return <Navigate to="/" replace />;

  return children;
};

export default PrivateRoute;